@let branding = facade.branding$ | async;
@let navigation = facade.navigation$ | async;
@let account = facade.account$ | async;

@if (branding && navigation && account) {
    <app-shell
        [branding]="branding"
        [navigation]="navigation"
        [account]="account"
        [currentUrl]="(facade.currentUrl$ | async) ?? ''"
        [loading]="(facade.loading$ | async) ?? true"
        [languages]="facade.languages"
        [currentLanguage]="(facade.currentLanguage$ | async) ?? ''"
        [freeTrialDaysLeft]="(facade.freeTrialDaysLeft$ | async) ?? null"
        [showPoweredBy]="facade.showPoweredBy"
        [controlledOrganization]="(facade.controlledOrganization$ | async) ?? null"
        (languageChange)="facade.changeLanguage($event)"
        (logout)="facade.logout()"
        (contactSales)="facade.contactSales()"
        (stopControlling)="facade.stopControlling()">
        <router-outlet />
        <app-loading-screen />
    </app-shell>
}
